module.exports = __webpack_public_path__ + "media/partners/reflex_logo-db25fa9f.png";